function showModal(target, $modal, $overlay, $body) {
  $modal.filter('[data-modal-id="' + target + '"]').addClass('is-show');
  $overlay.addClass('is-show');
  $body.addClass('is-fixed');
}

function hideModal($modal, $overlay, $body) {
  $modal.removeClass('is-show');
  $overlay.removeClass('is-show');
  $body.removeClass('is-fixed');
}

function runModal() {
  const $body = $('body');
  const $modal = $('.js-modal');
  const $link = $('.js-modalLink');
  const $overlay = $('.js-modalOverlay');
  const $close = $('.js-modalClose');

  $link.on('click', function (e) {
    e.preventDefault();
    const target = $(this).data('modal-target');
    showModal(target, $modal, $overlay, $body);
  });

  $modal.on('click', function (e) {
    e.stopPropagation();
  });

  $close.on('click', function () {
    hideModal($modal, $overlay, $body);
  });
}

$(function () {
  runModal();
});
